import { FaRegKeyboard, FaShieldVirus } from "react-icons/fa";
import { GiGraduateCap } from "react-icons/gi";
import { LuDroplet, LuSearchCode } from "react-icons/lu";
import {Battery,Fan,Keyboard,Screen,ScreenCreack,Software,Virus} from "../../assets/services"
import {BlueCorornavirus, BlueLaptopForm,Image12, Profile} from "../../assets/Home"
export const Services = [
  {
    id: 1,
    title: "Battery Replacement",
    desc: "Is your laptop running out of power quickly or failing to charge? Our battery replacement service is designed to restore your device’s",
    price: "799",
    oldPrice: "899",
    discountPercent:10,
    tag: "Prices up-to-10% lower",
    icon: Battery,
    images:[Battery,Fan,Screen,BlueCorornavirus],
    services:["Shouldering keyboard","Numeric  keyboard","Normal  keyboard","Back-light  keyboard","Trackball keyboard"],
    reviews: [
      { user: "Amit", rating: 5, comment: "Great performance and build quality.",img: Profile },
      { user: "Ravi", rating: 4, comment: "Sleek and powerful machine.",img: Profile },
      { user: "Amit", rating: 5, comment: "Great performance and build quality.",img: Profile },
      { user: "Ravi", rating: 4, comment: "Sleek and powerful machine.",img: Profile },
      { user: "Amit", rating: 5, comment: "Great performance and build quality.",img: Profile },
      { user: "Ravi", rating: 4, comment: "Sleek and powerful machine.",img: Profile },
    ],
    offered:[
      {
        name:"Warranty Coverage ",
        icon:FaShieldVirus,
      },
      {
        name:"Expert technician",
        icon:GiGraduateCap ,
      },
      {
        name:"High Quality Parts",
        icon:FaRegKeyboard,
      },
      {
        name:"Multi-brand Support",
        icon:LuSearchCode,
      },
      {
        name:"Water Damage",
        icon:LuDroplet,
      },
    ],
    moreInfo:[
      {
        name:"Our keyboard replacement service covers a wide range of issues",
        values:["numeric keypad repairs"," backlight malfunctions","standard keyboard problems"],
      },
      {
        name:"We also offer specialized services like",
        values:["trackball and soldering repairs for advanced keyboard setups.","Whether you’re dealing with unresponsive keys","backlight issues","backlight issues","numeric pad"],
      },
      {
        name:"Our skilled technicians ensure precise and high-quality replacements for all laptop models. Trust us for quick, reliable service that restores your device’s full functionality.",
        values:[],
      },
    ]
  },
  {
    id: 2,
    title: "Screen Replacement",
    desc: "Is your laptop running out of power quickly or failing to charge? Our battery replacement service is designed to restore your device’s",
    price: "799",
    oldPrice: "899",
    tag: "Prices up-to-10% lower",
    icon: Screen,
    images:[Battery,Fan,Screen,BlueCorornavirus],
    discountPercent:10,
     services:["Shouldering keyboard","Numeric  keyboard","Normal  keyboard","Back-light  keyboard","Trackball keyboard"],
    reviews: [
      { user: "Amit", rating: 5, comment: "Great performance and build quality.",img: Profile },
      { user: "Ravi", rating: 4, comment: "Sleek and powerful machine.",img: Profile }
    ],
    offered:[
      {
        name:"Warranty Coverage ",
        icon:FaShieldVirus,
      },
      {
        name:"Expert technician",
        icon:GiGraduateCap ,
      },
      {
        name:"High Quality Parts",
        icon:FaRegKeyboard,
      },
      {
        name:"Multi-brand Support",
        icon:LuSearchCode,
      },
      {
        name:"Water Damage",
        icon:LuDroplet,
      },
    ],
    moreInfo:[
      {
        name:"Our keyboard replacement service covers a wide range of issues",
        values:["numeric keypad repairs"," backlight malfunctions","standard keyboard problems"],
      },
      {
        name:"We also offer specialized services like",
        values:["trackball and soldering repairs for advanced keyboard setups.","Whether you’re dealing with unresponsive keys","backlight issues","backlight issues","numeric pad"],
      },
      {
        name:"Our skilled technicians ensure precise and high-quality replacements for all laptop models. Trust us for quick, reliable service that restores your device’s full functionality.",
        values:[],
      },
    ]
  },
  {
    id: 3,
    title: "Keyboard Repair",
    desc: "Is your laptop running out of power quickly or failing to charge? Our battery replacement service is designed to restore your device’s",
    price: "799",
    oldPrice: "899",
    discountPercent:10,
    tag: "Prices up-to-10% lower",
    icon: Keyboard,
    images:[Battery,Fan,Screen,BlueCorornavirus],
     services:["Shouldering keyboard","Numeric  keyboard","Normal  keyboard","Back-light  keyboard","Trackball keyboard"],
    reviews: [
      { user: "Amit", rating: 5, comment: "Great performance and build quality.",img: Profile },
      { user: "Ravi", rating: 4, comment: "Sleek and powerful machine.",img: Profile }
    ],
    offered:[
      {
        name:"Warranty Coverage ",
        icon:FaShieldVirus,
      },
      {
        name:"Expert technician",
        icon:GiGraduateCap ,
      },
      {
        name:"High Quality Parts",
        icon:FaRegKeyboard,
      },
      {
        name:"Multi-brand Support",
        icon:LuSearchCode,
      },
      {
        name:"Water Damage",
        icon:LuDroplet,
      },
    ],
    moreInfo:[
      {
        name:"Our keyboard replacement service covers a wide range of issues",
        values:["numeric keypad repairs"," backlight malfunctions","standard keyboard problems"],
      },
      {
        name:"We also offer specialized services like",
        values:["trackball and soldering repairs for advanced keyboard setups.","Whether you’re dealing with unresponsive keys","backlight issues","backlight issues","numeric pad"],
      },
      {
        name:"Our skilled technicians ensure precise and high-quality replacements for all laptop models. Trust us for quick, reliable service that restores your device’s full functionality.",
        values:[],
      },
    ]
  },
  {
    id: 4,
    title: "Software Troubleshooting & Installation",
    desc: "Is your laptop running out of power quickly or failing to charge? Our battery replacement service is designed to restore your device’s",
    price: "799",
    oldPrice: "899",
    discountPercent:10,
    tag: "Prices up-to-10% lower",
    icon: Software,
    images:[Battery,Fan,Screen,BlueCorornavirus],
     services:["Shouldering keyboard","Numeric  keyboard","Normal  keyboard","Back-light  keyboard","Trackball keyboard"],
    reviews: [
      { user: "Amit", rating: 5, comment: "Great performance and build quality.",img: Profile },
      { user: "Ravi", rating: 4, comment: "Sleek and powerful machine.",img: Profile }
    ],
    offered:[
      {
        name:"Warranty Coverage ",
        icon:FaShieldVirus,
      },
      {
        name:"Expert technician",
        icon:GiGraduateCap ,
      },
      {
        name:"High Quality Parts",
        icon:FaRegKeyboard,
      },
      {
        name:"Multi-brand Support",
        icon:LuSearchCode,
      },
      {
        name:"Water Damage",
        icon:LuDroplet,
      },
    ],
    moreInfo:[
      {
        name:"Our keyboard replacement service covers a wide range of issues",
        values:["numeric keypad repairs"," backlight malfunctions","standard keyboard problems"],
      },
      {
        name:"We also offer specialized services like",
        values:["trackball and soldering repairs for advanced keyboard setups.","Whether you’re dealing with unresponsive keys","backlight issues","backlight issues","numeric pad"],
      },
      {
        name:"Our skilled technicians ensure precise and high-quality replacements for all laptop models. Trust us for quick, reliable service that restores your device’s full functionality.",
        values:[],
      },
    ]
  },
  {
    id: 5,
    title: "Basic Inception & Diagnosis",
    desc: "Is your laptop running out of power quickly or failing to charge? Our battery replacement service is designed to restore your device’s",
   price: "799",
    oldPrice: "899",
    tag: "Prices up-to-10% lower",
    icon: Software,
    images:[Battery,Fan,Screen,BlueCorornavirus],
    discountPercent:10,
     services:["Shouldering keyboard","Numeric  keyboard","Normal  keyboard","Back-light  keyboard","Trackball keyboard"],
    reviews: [
      { user: "Amit", rating: 5, comment: "Great performance and build quality.",img: Profile },
      { user: "Ravi", rating: 4, comment: "Sleek and powerful machine.",img: Profile }
    ],
    offered:[
      {
        name:"Warranty Coverage ",
        icon:FaShieldVirus,
      },
      {
        name:"Expert technician",
        icon:GiGraduateCap ,
      },
      {
        name:"High Quality Parts",
        icon:FaRegKeyboard,
      },
      {
        name:"Multi-brand Support",
        icon:LuSearchCode,
      },
      {
        name:"Water Damage",
        icon:LuDroplet,
      },
    ],
    moreInfo:[
      {
        name:"Our keyboard replacement service covers a wide range of issues",
        values:["numeric keypad repairs"," backlight malfunctions","standard keyboard problems"],
      },
      {
        name:"We also offer specialized services like",
        values:["trackball and soldering repairs for advanced keyboard setups.","Whether you’re dealing with unresponsive keys","backlight issues","backlight issues","numeric pad"],
      },
      {
        name:"Our skilled technicians ensure precise and high-quality replacements for all laptop models. Trust us for quick, reliable service that restores your device’s full functionality.",
        values:[],
      },
    ]
  },
  {
    id: 6,
    title: "Fan Repair & Overheating Solutions",
    desc: "Is your laptop running out of power quickly or failing to charge? Our battery replacement service is designed to restore your device’s",
    price: "799",
    oldPrice: "899",
    tag: "Prices up-to-10% lower",
    icon: Fan,
    images:[Battery,Fan,Screen,BlueCorornavirus],
    discountPercent:10,
     services:["Shouldering keyboard","Numeric  keyboard","Normal  keyboard","Back-light  keyboard","Trackball keyboard"],
    reviews: [
      { user: "Amit", rating: 5, comment: "Great performance and build quality.",img: Profile },
      { user: "Ravi", rating: 4, comment: "Sleek and powerful machine.",img: Profile }
    ],
    offered:[
      {
        name:"Warranty Coverage ",
        icon:FaShieldVirus,
      },
      {
        name:"Expert technician",
        icon:GiGraduateCap ,
      },
      {
        name:"High Quality Parts",
        icon:FaRegKeyboard,
      },
      {
        name:"Multi-brand Support",
        icon:LuSearchCode,
      },
      {
        name:"Water Damage",
        icon:LuDroplet,
      },
    ],
    moreInfo:[
      {
        name:"Our keyboard replacement service covers a wide range of issues",
        values:["numeric keypad repairs"," backlight malfunctions","standard keyboard problems"],
      },
      {
        name:"We also offer specialized services like",
        values:["trackball and soldering repairs for advanced keyboard setups.","Whether you’re dealing with unresponsive keys","backlight issues","backlight issues","numeric pad"],
      },
      {
        name:"Our skilled technicians ensure precise and high-quality replacements for all laptop models. Trust us for quick, reliable service that restores your device’s full functionality.",
        values:[],
      },
    ]
  },
  { 
    id:7,
    title: "Replace faulty batteries", 
    desc: "Is your laptop running out of power quickly or failing to charge? Our battery replacement service is designed to restore your device’s",
    price: "999", 
    oldPrice: "1599",
    icon: Battery, 
    images:[Battery,Fan,Screen,BlueCorornavirus],
    tag: "Prices up-to-10% lower",
    services:["Shouldering keyboard","Numeric  keyboard","Normal  keyboard","Back-light  keyboard","Trackball keyboard"],
    discountPercent:10,
    reviews: [
      { user: "Amit", rating: 5, comment: "Great performance and build quality.",img: Profile },
      { user: "Ravi", rating: 4, comment: "Sleek and powerful machine.",img: Profile }
    ],
    offered:[
      {
        name:"Warranty Coverage ",
        icon:FaShieldVirus,
      },
      {
        name:"Expert technician",
        icon:GiGraduateCap ,
      },
      {
        name:"High Quality Parts",
        icon:FaRegKeyboard,
      },
      {
        name:"Multi-brand Support",
        icon:LuSearchCode,
      },
      {
        name:"Water Damage",
        icon:LuDroplet,
      },
    ],
    moreInfo:[
      {
        name:"Our keyboard replacement service covers a wide range of issues",
        values:["numeric keypad repairs"," backlight malfunctions","standard keyboard problems"],
      },
      {
        name:"We also offer specialized services like",
        values:["trackball and soldering repairs for advanced keyboard setups.","Whether you’re dealing with unresponsive keys","backlight issues","backlight issues","numeric pad"],
      },
      {
        name:"Our skilled technicians ensure precise and high-quality replacements for all laptop models. Trust us for quick, reliable service that restores your device’s full functionality.",
        values:[],
      },
    ]
  },
  { 
    id:8,
    title: "Malware & Virus", 
    desc: "Is your laptop running out of power quickly or failing to charge? Our battery replacement service is designed to restore your device’s",
    price: "699",
    oldPrice: "899",
    icon: Virus,
    images:[Battery,Fan,Screen,BlueCorornavirus],
    discountPercent:10,
    tag: "Prices up-to-10% lower",
    services:["Shouldering keyboard","Numeric  keyboard","Normal  keyboard","Back-light  keyboard","Trackball keyboard"],
    reviews: [
      { user: "Amit", rating: 5, comment: "Great performance and build quality.",img: Profile },
      { user: "Ravi", rating: 4, comment: "Sleek and powerful machine.",img: Profile }
    ],
    offered:[
      {
        name:"Warranty Coverage ",
        icon:FaShieldVirus,
      },
      {
        name:"Expert technician",
        icon:GiGraduateCap ,
      },
      {
        name:"High Quality Parts",
        icon:FaRegKeyboard,
      },
      {
        name:"Multi-brand Support",
        icon:LuSearchCode,
      },
      {
        name:"Water Damage",
        icon:LuDroplet,
      },
    ],
    moreInfo:[
      {
        name:"Our keyboard replacement service covers a wide range of issues",
        values:["numeric keypad repairs"," backlight malfunctions","standard keyboard problems"],
      },
      {
        name:"We also offer specialized services like",
        values:["trackball and soldering repairs for advanced keyboard setups.","Whether you’re dealing with unresponsive keys","backlight issues","backlight issues","numeric pad"],
      },
      {
        name:"Our skilled technicians ensure precise and high-quality replacements for all laptop models. Trust us for quick, reliable service that restores your device’s full functionality.",
        values:[],
      },
    ]
 },
 { 
    id:9,
    title: "Fan Noise Reduction",
    desc: "Is your laptop running out of power quickly or failing to charge? Our battery replacement service is designed to restore your device’s", 
    price: "849", 
    oldPrice: "1699",
    discountPercent:10,
    icon: BlueLaptopForm ,
    images:[Battery,Fan,Screen,BlueCorornavirus],
    tag: "Prices up-to-10% lower",
    services:["Shouldering keyboard","Numeric  keyboard","Normal  keyboard","Back-light  keyboard","Trackball keyboard"],
    reviews: [
      { user: "Amit", rating: 5, comment: "Great performance and build quality.",img: Profile },
      { user: "Ravi", rating: 4, comment: "Sleek and powerful machine.",img: Profile }
    ],
    offered:[
      {
        name:"Warranty Coverage ",
        icon:FaShieldVirus,
      },
      {
        name:"Expert technician",
        icon:GiGraduateCap ,
      },
      {
        name:"High Quality Parts",
        icon:FaRegKeyboard,
      },
      {
        name:"Multi-brand Support",
        icon:LuSearchCode,
      },
      {
        name:"Water Damage",
        icon:LuDroplet,
      },
    ],
    moreInfo:[
      {
        name:"Our keyboard replacement service covers a wide range of issues",
        values:["numeric keypad repairs"," backlight malfunctions","standard keyboard problems"],
      },
      {
        name:"We also offer specialized services like",
        values:["trackball and soldering repairs for advanced keyboard setups.","Whether you’re dealing with unresponsive keys","backlight issues","backlight issues","numeric pad"],
      },
      {
        name:"Our skilled technicians ensure precise and high-quality replacements for all laptop models. Trust us for quick, reliable service that restores your device’s full functionality.",
        values:[],
      },
    ]
},
 { 
    id:10,
    title: "Screen Cracks", 
    desc: "Is your laptop running out of power quickly or failing to charge? Our battery replacement service is designed to restore your device’s",
    price: "899", 
    oldPrice: "999",
    icon: ScreenCreack ,
    images:[Battery,Fan,Screen,BlueCorornavirus],
    discountPercent:10,
    tag: "Prices up-to-10% lower",
    services:["Shouldering keyboard","Numeric  keyboard","Normal  keyboard","Back-light  keyboard","Trackball keyboard"],
    reviews: [
      { user: "Amit", rating: 5, comment: "Great performance and build quality.",img: Profile },
      { user: "Ravi", rating: 4, comment: "Sleek and powerful machine.",img: Profile }
    ],
    offered:[
      {
        name:"Warranty Coverage ",
        icon:FaShieldVirus,
      },
      {
        name:"Expert technician",
        icon:GiGraduateCap ,
      },
      {
        name:"High Quality Parts",
        icon:FaRegKeyboard,
      },
      {
        name:"Multi-brand Support",
        icon:LuSearchCode,
      },
      {
        name:"Water Damage",
        icon:LuDroplet,
      },
    ],
    moreInfo:[
      {
        name:"Our keyboard replacement service covers a wide range of issues",
        values:["numeric keypad repairs"," backlight malfunctions","standard keyboard problems"],
      },
      {
        name:"We also offer specialized services like",
        values:["trackball and soldering repairs for advanced keyboard setups.","Whether you’re dealing with unresponsive keys","backlight issues","backlight issues","numeric pad"],
      },
      {
        name:"Our skilled technicians ensure precise and high-quality replacements for all laptop models. Trust us for quick, reliable service that restores your device’s full functionality.",
        values:[],
      },
    ]
 },
 { 
  id:11,
  title: "Recover Data", 
  desc: "Is your laptop running out of power quickly or failing to charge? Our battery replacement service is designed to restore your device’s",
  price: "899", 
  oldPrice: "999",
  icon: Image12, 
  images:[Battery,Fan,Screen,BlueCorornavirus],
  tag: "Prices up-to-10% lower",
  services:["Shouldering keyboard","Numeric  keyboard","Normal  keyboard","Back-light  keyboard","Trackball keyboard"],
    reviews: [
      { user: "Amit", rating: 5, comment: "Great performance and build quality.",img: Profile },
      { user: "Ravi", rating: 4, comment: "Sleek and powerful machine.",img: Profile }
    ],
    offered:[
      {
        name:"Warranty Coverage ",
        icon:FaShieldVirus,
      },
      {
        name:"Expert technician",
        icon:GiGraduateCap ,
      },
      {
        name:"High Quality Parts",
        icon:FaRegKeyboard,
      },
      {
        name:"Multi-brand Support",
        icon:LuSearchCode,
      },
      {
        name:"Water Damage",
        icon:LuDroplet,
      },
    ],
    moreInfo:[
      {
        name:"Our keyboard replacement service covers a wide range of issues",
        values:["numeric keypad repairs"," backlight malfunctions","standard keyboard problems"],
      },
      {
        name:"We also offer specialized services like",
        values:["trackball and soldering repairs for advanced keyboard setups.","Whether you’re dealing with unresponsive keys","backlight issues","backlight issues","numeric pad"],
      },
      {
        name:"Our skilled technicians ensure precise and high-quality replacements for all laptop models. Trust us for quick, reliable service that restores your device’s full functionality.",
        values:[],
      },
    ]
},
];
